// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3JvZ_","inputWrap":"styles_inputWrap__3GjN-","input":"styles_input__363y7"};